import {
    useNavigate,
} from "react-router-dom";

function NotFoundPage() {

    const navigate =
        useNavigate();

    return (

        <div style={styles.page}>

            <div style={styles.card}>

                <div style={styles.code}>
                    404
                </div>

                <h1 style={styles.title}>
                    Page Not Found
                </h1>

                <p style={styles.subtitle}>

                    The page you are looking for
                    does not exist.

                </p>

                <button

                    style={styles.button}

                    onClick={() =>
                        navigate("/")
                    }
                >

                    Go Home

                </button>

            </div>

        </div>
    );
}

const styles = {

    page: {

        minHeight: "100vh",

        display: "flex",

        justifyContent: "center",

        alignItems: "center",

        padding: "20px",

        background:
            "linear-gradient(111.1deg, rgb(0,40,70) -4.8%, rgb(255,229,115) 82.7%, rgb(255,203,15) 97.2%)",
    },

    card: {

        background:
            "rgba(0,40,70,0.82)",

        padding: "48px",

        borderRadius: "28px",

        textAlign: "center",

        maxWidth: "500px",

        width: "100%",

        border:
            "1px solid rgba(255,255,255,0.08)",

        backdropFilter:
            "blur(10px)",
    },

    code: {

        fontSize: "88px",

        fontWeight: "900",

        lineHeight: 1,

        marginBottom: "20px",

        background:
            "linear-gradient(90deg, #00ff88, #00d4ff)",

        WebkitBackgroundClip:
            "text",

        WebkitTextFillColor:
            "transparent",
    },

    title: {

        color: "#fff",

        fontSize: "32px",

        fontWeight: "800",

        marginBottom: "12px",
    },

    subtitle: {

        color: "#cbd5e1",

        fontSize: "15px",

        lineHeight: 1.6,

        marginBottom: "28px",
    },

    button: {

        border: "none",

        borderRadius: "999px",

        padding: "14px 24px",

        fontWeight: "800",

        cursor: "pointer",

        background:
            "linear-gradient(90deg, #00ff88, #00d4ff)",
    },
};

export default NotFoundPage;